"use client"

import { Baseline } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BaselineIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BaselineIcon = component(Icon)({ as: Baseline })
